import { faqs } from '@/mocks/data';

export default function FAQSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-3">
            FAQ
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">关于51黑料网，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group rounded-2xl bg-background-100 overflow-hidden">
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <span className="text-sm md:text-base font-bold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-500 group-open:text-background-50 transition-colors duration-200 flex-shrink-0">
                  <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}